import { CardTransactionDTO, CardTransactionType, PaymentDTO, PaymentMethodDTO } from 'core/api';

export function create(method: PaymentMethodDTO, amount: number, tipAmount = 0, cardTransaction?: CardTransactionDTO): PaymentDTO {
	return {
		AllowExtraInformation: method.AllowExtraInformation,
		AllowOverPaid: method.AllowOverPaid,
		GiveChange: method.GiveChange,
		IsCash: method.IsCash,
		MethodId: method.Id,
		MethodName: method.Name,
		RegisterTip: method.RegisterTip,
		UseCardProcessor: method.UseCardProcessor,
		Amount: amount,
		TipAmount: tipAmount,
		CardTransaction: cardTransaction ?? { TransactionId: '', XmlDetails: '', TransactionType: CardTransactionType.Redsys },
		ExtraInformation: '',
		IsRefundVoucher: method.IsRefundVoucher
	};
}

export function createCash(amount: number, tipAmount = 0): PaymentDTO {
	return {
		AllowExtraInformation: false,
		AllowOverPaid: true,
		GiveChange: true,
		IsCash: true,
		MethodId: 1,
		MethodName: '',
		RegisterTip: false,
		UseCardProcessor: false,
		Amount: amount,
		TipAmount: tipAmount,
		CardTransaction: { TransactionId: '', XmlDetails: '', TransactionType: CardTransactionType.Redsys },
		ExtraInformation: '',
		IsRefundVoucher: false
	};
}